// Fix fri_sat, sat_sun, notice they are the same
const config = {
  lang_fi: {
    fri_sat: {
      from: { day: 5, hour: 21 },
      to: { day: 6, hour: 9 }
    },
    sat_sun: {
      from: { day: 5, hour: 21 },
      to: { day: 6, hour: 9 }
    }
  },
  lang_se: {
    fri_sat: {
      from: { day: 5, hour: 21 },
      to: { day: 6, hour: 9 }
    },
    sat_sun: {
      from: { day: 5, hour: 21 },
      to: { day: 6, hour: 9 }
    }
  },
  lang_no: {
    fri_sat: {
      from: { day: 5, hour: 21 },
      to: {  day: 6, hour: 9 }
    },
    sat_sun: {
      from: { day: 5, hour: 21 },
      to: { day: 6, hour: 9 }
    }
  },
  lang_dk: {
    fri_sat: {
      from: { day: 5, hour: 18 },
      to: { day: 6, hour: 10 }
    },
    sat_sun: {
      from: { day: 6, hour: 16 },
      to: { day: 0, hour: 10 } 
    }
  },
  lang_en: {
    fri_sat: {
      from: { day: 5, hour: 21 },
      to: { day: 6, hour: 9 }
    },
    sat_sun: {
      from: { day: 5, hour: 21 },
      to: { day: 6, hour: 9 }
    }
  }
}

// getWeekendId :: (string, Date) => string
export const getWeekendId = (country, now) => {
  if (country in config) {
    const ranges = config[country];
    const day = now.getDay()
    const hour = now.getHours();
    for (let key of Object.keys(ranges)) {
      if (day === ranges[key].from.day && hour < ranges[key].from.hour) {
        return key
      }
    }
  }
  return 'normal';
}